import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { omit } from 'lodash'

const omitProps = ['enabled', 'allowTouchMove']
const getPassedProps = props => omit(props, omitProps)

class BodyScrollLock extends Component {
  static propTypes = {
    enabled: PropTypes.bool
  }

  static defaultProps = {
    enabled: true
  }

  targetRef = React.createRef()

  componentDidMount () {
    this.targetElement = this.targetRef.current

    this.enableLock()
  }

  componentDidUpdate ({ enabled: prevEnabled }) {
    const { enabled } = this.props

    if (Boolean(prevEnabled) === Boolean(enabled)) {
      return
    }

    if (enabled) {
      this.enableLock()
    } else {
      this.disableLock()
    }
  }

  componentWillUnmount () {
    this.disableLock()
  }

  enableLock () {
    const { enabled, allowTouchMove } = this.props
    if (!enabled) {
      return false
    }
    disableBodyScroll(this.targetElement, {
      allowTouchMove: allowTouchMove ? () => true : undefined
    })
  }

  disableLock () {
    enableBodyScroll(this.targetElement)
  }

  render () {
    return <div ref={this.targetRef} {...getPassedProps(this.props)} />
  }
}

export default BodyScrollLock
